import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { ConvexReactClient } from "convex/react";
import { App } from "./App";
import "./index.css";

const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string);

const root = createRoot(document.getElementById("root")!);

function renderApp() {
  root.render(
    <StrictMode>
      <ConvexAuthProvider client={convex}>
        <App />
      </ConvexAuthProvider>
    </StrictMode>,
  );
}

function clearConvexAuthTokens() {
  const convexUrl = import.meta.env.VITE_CONVEX_URL as string;
  const namespace = convexUrl.replace(/[^a-zA-Z0-9]/g, "");
  for (const key of [`__convexAuthJWT_${namespace}`, `__convexAuthRefreshToken_${namespace}`]) {
    localStorage.removeItem(key);
  }
}

window.addEventListener("unhandledrejection", (event) => {
  const msg = event.reason?.message ?? String(event.reason);
  if (msg.includes("OIDC token") || msg.includes("AuthError")) {
    event.preventDefault();
    const lastClear = sessionStorage.getItem("__convexAuthCleared");
    if (lastClear && Date.now() - Number(lastClear) < 5000) return;
    sessionStorage.setItem("__convexAuthCleared", String(Date.now()));
    clearConvexAuthTokens();
    window.location.reload();
  }
});

renderApp();
